<script lang="ts">
	import { Loader } from '@lucide/svelte';
</script>

<Loader class="mr-3 h-6 w-6 animate-spin text-neutral-800 dark:text-neutral-300" />
